(function(){

	function generateHtmlForEnumeration(propObj, selectedValue, template, textSort){
		var out = '';
		var selectList = new Array()
		var index=0;
		var compiledTemplate = Handlebars.compile(template);
		for(var value in propObj){
			if(propObj.hasOwnProperty(value)){
				var selected = '';
				var text = propObj[value];
				
				if(value == selectedValue){
					selected = 'selected';
				}
				selectList.push({value: value, selected: selected, text: text, index: index});
				index++;
			}
		}

		//this step will sort the select list alphabetically by the text field
		if(textSort)
			selectList.sort(function(a,b) {  
				var textA = a.text.toUpperCase();
				var textB = b.text.toUpperCase();
				
				if(textA < textB) 
					return -1

				if(textA > textB)
					return 1;

				return 0;
			});

		for(var i in selectList) {
			var obj = selectList[i];
			out += compiledTemplate({'value' : obj.value, 'selected' : obj.selected, 'text' : obj.text, 'index' : obj.index});
		}

		return out;
	}
	
	function generatePropertyObjectFromEnumeration(enumeration, propertyName){
		var propertyObj = {};
		_(_(enumeration).keys()).each(function(value){
			var text = enumeration[value][propertyName];
			if(!_(text).isUndefined()){
				propertyObj[value] = text;
			}
			return;
		});
		
		return propertyObj;
	}

	function generatePropertyObjectFromCollection(collection, valuePropertyName, textPropertyName){
		var propertyObj = {};
		_(collection.models).each(function(model){
			var value = model.get(valuePropertyName);
			var text = model.get(textPropertyName);

			if(!_(text).isUndefined()){
				propertyObj[value] = text;
			}
			return;
		});
		
		return propertyObj;
	}

	function generatePropertyObjectFromArray(theArray, valuePropertyName, textPropertyName){
		var propertyObj = {};
		_(theArray).each(function(model){
			var value = model[valuePropertyName];
			var text = model[textPropertyName];

			if(!_(text).isUndefined()){
				propertyObj[value] = text;
			}
			return;
		});
		
		return propertyObj;
	}
	// Iterate through an object, passing each as 'key' and 'value'
	//
	// Usage:
	// var t = Handlebars.compile('<ul>{{#key_value foo}}<li>{{key}}: {{value}}</li>{{/key_value}}</ul>');
	// t({foo: {a:1, b:2}})
	//
	// Output:
	// "<ul><li>a: 1</li><li>b: 2</li></ul>"
	try {
		Handlebars = require("handlebars-old");
	} catch (e) {}
	Handlebars.registerHelper("key_value", function(obj, fn) {
		var buffer = "",
			key;

		for (key in obj) {
			if (obj.hasOwnProperty(key)) {
				buffer += fn({key: key, value: obj[key]});
			}
		}

		return buffer;
	});

	Handlebars.registerHelper('containsValue', function(array, value, fn, elseFn) {
		if(!_(array).isArray()) {
			array = [array]; //If its just a value, make it an array with one value
		}

		if(_.include(array, value)){
			return fn();
		} else {
			return elseFn();
		}
	});

	Handlebars.registerHelper('ifEqual', function(value1, value2, fn, elseFn) {
		if(value1 === value2){
			return fn(this);
		} else {
			return elseFn(this);
		}
	});
	
	Handlebars.registerHelper('createDropdownSelectorFromCollection', function(collection, valuePropertyName, textPropertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromCollection(collection, valuePropertyName, textPropertyName);
		return  "<select>" + generateHtmlForEnumeration(propertyObject, selectedValue, "<option {{selected}} value='{{value}}'>{{text}}</option>", textSort) + "</select>";
	});

	Handlebars.registerHelper('createBootstrapDropdownSelectorFromArray', function(theArray, valuePropertyName, textPropertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromArray(theArray, valuePropertyName, textPropertyName);
		return  "<ul class='dropdown-menu'>" + generateHtmlForEnumeration(propertyObject, selectedValue, "<li class='{{selected}}' data-value='{{value}}'><a href='#'>{{text}}</a></li>", textSort) + "</ul>";
	});

	Handlebars.registerHelper('createInlineSelectorFromEnumeration', function(enumeration, propertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromEnumeration(enumeration, propertyName);
		return  "<div class='inlineSelector' >" + generateHtmlForEnumeration(propertyObject, selectedValue, "<span class='item {{selected}}' data-id='{{value}}'>{{text}}</span>", textSort) + "</div>";
				
	});

	Handlebars.registerHelper('createBootstrapInlineSelectorFromEnumeration', function(enumeration, propertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromEnumeration(enumeration, propertyName);
		return  "<div class='btn-group' data-toggle='buttons-radio' >" + generateHtmlForEnumeration(propertyObject, selectedValue, "<button type='button' class='btn {{selected}}' data-id='{{value}}'>{{text}}</button>", textSort) + "</div>";
				
	});

	Handlebars.registerHelper('createVerticalSelectorFromEnumeration', function(enumeration, propertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromEnumeration(enumeration, propertyName);
		return  "<div class='MDAdjustableSelector' >" + generateHtmlForEnumeration(propertyObject, selectedValue, "<div class='item {{selected}}' data-index={{index}} data-id='{{value}}'>{{text}}</div>", textSort) + "</div>";
				
	});

	Handlebars.registerHelper('createDropdownSelectorFromEnumeration', function(enumeration, propertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromEnumeration(enumeration, propertyName);
		return  "<select>" + generateHtmlForEnumeration(propertyObject, selectedValue, "<option {{selected}} value='{{value}}'>{{text}}</option>", textSort) + "</select>";
	});

	Handlebars.registerHelper('createBootstrapDropdownSelectorFromEnumeration', function(enumeration, propertyName, selectedValue, textSort) {
		var propertyObject = generatePropertyObjectFromEnumeration(enumeration, propertyName);
		return  "<ul class='dropdown-menu'>" + generateHtmlForEnumeration(propertyObject, selectedValue, "<li class='{{selected}}' data-value='{{value}}'><a href='javascript: void(0)'>{{text}}</a></li>", textSort) + "</ul>";
	});

	Handlebars.registerHelper('createDropDownSelectorFromPropertyObj', function(propertyObject, propertyName, selectedValue, textSort) {
		return  "<select>" + generateHtmlForEnumeration(propertyObject, selectedValue, "<option {{selected}} value='{{value}}'>{{text}}</option>", textSort) + "</select>";
	});

})();
